<template>
  <div class="Container">
    <b-container>
      <div class="mainDiv">
        <div>
          <span>
            <p href="Dashboard" class="returnLink" v-on:click="backToDash()">
              Return to Dashboard
            </p>

            <!-- <b-nav-item to="/Dashboard" v-show="$route.name !== 'Home'"
              ><p class="Menu">Dashboard</p></b-nav-item
            > -->
          </span>
          <div class="deviceDetails">
            <h1 class="pageHeader">Device Detail Report</h1>

            <b-row class="deviceInfo" v-if="this.Multipipe != 'TRUE'">
              <b-col sm="3">
                <p class="headerText">
                  Device:
                  <span class="dataText"> <br />{{ this.DeviceID }}</span>
                </p>
              </b-col>
              <b-col sm="3">
                <p class="headerText">
                  Location:
                  <span class="dataText"> <br />St Simons Hospital </span>
                </p>
              </b-col>
              <b-col sm="3">
                <p class="headerText">
                  Position:
                  <span class="dataText"> <br />{{ this.Position }} </span>
                </p>
              </b-col>
              <b-col sm="3">
                <p v-if="this.Score > 850" class="headerText">
                  Current Risk Level:
                  <span class="dataText">
                    <br />
                    Low Risk
                  </span>
                </p>
                <p
                  v-if="(this.Score < 850) & (this.Score >= 500)"
                  class="headerText"
                >
                  Current Risk Level:
                  <span class="dataText">
                    <br />
                    Moderate Risk
                  </span>
                </p>
                <p
                  v-if="(this.Score < 500) & (this.Score > 150)"
                  class="headerText"
                >
                  Current Risk Level:
                  <span class="dataText">
                    <br />
                    High Risk
                  </span>
                </p>
                <p
                  v-if="(this.Score < 150) & (this.Score >= 0)"
                  class="headerText"
                >
                  Current Risk Level:
                  <span class="dataText">
                    <br />
                    Extremely High Risk
                  </span>
                </p>
              </b-col>
            </b-row>
            <b-row class="deviceInfo" v-if="this.Multipipe == 'TRUE'">
              <b-col sm="4">
                <p class="headerText">
                  Device:
                  <span class="dataText"> <br />{{ this.DeviceID }}</span>
                </p>
              </b-col>
              <b-col sm="4">
                <p class="headerText">
                  Location:
                  <span class="dataText"> <br />{{ this.Location }} </span>
                </p>
              </b-col>
              <b-col sm="4">
                <p class="headerText">
                  Position:
                  <span class="dataText"> <br />{{ this.Position }} </span>
                </p>
              </b-col>
            </b-row>
          </div>
          <div class="filterBox">
            <b-row>
              <p id="Selector">Select Date Range to Filter by</p>
            </b-row>
            <b-row>
              <b-col
                ><p id="Selector">
                  From Date: <br />
                  <b-form-datepicker
                    type="date"
                    v-model="FromDate"
                    @focus="modal = false"
                  />
                </p>
              </b-col>
              <b-col
                ><p id="Selector">
                  To Date: <br />
                  <b-form-datepicker
                    type="date"
                    v-model="ToDate"
                    @focus="modal = false"
                  />
                </p>
              </b-col>
            </b-row>
            <b-row v-if="this.Multipipe == 'TRUE'">
              <p id="Selector">Select a Specific Pipe's Data</p>

              <b-col>
                <b-row> <p id="Selector">Pipe A</p> </b-row>
                <b-row>
                  <b-form-checkbox
                    v-model="PipeAShow"
                    value="true"
                    unchecked-value="false"
                    switch
                    class="checkboxDiv"
                  ></b-form-checkbox>
                </b-row>
              </b-col>
              <b-col>
                <b-row> <p id="Selector">Pipe B</p> </b-row>
                <b-row>
                  <b-form-checkbox
                    v-model="PipeBShow"
                    value="true"
                    unchecked-value="false"
                    switch
                    class="checkboxDiv"
                  ></b-form-checkbox>
                </b-row>
              </b-col>
            </b-row>
            <b-row class="SubmitRow">
              <b-col>
                <p id="Selector">
                  <button
                    id="button"
                    class="button"
                    v-on:click="DynamicSelect()"
                  >
                    Submit
                  </button>
                  <button id="button" class="button" v-on:click="resetValue()">
                    Clear
                  </button>
                </p>
              </b-col>
            </b-row>
            <!-- START OF DATA DISPLAY -->
            <div
              v-if="this.MultipipeDataShow == true || this.Multipipe != 'TRUE'"
            >
              <div>
                <div>
                  <img
                    id="menuGraphic"
                    align="right"
                    src="../assets/PDFIconSmall.png"
                    v-on:click="generateReport()"
                  />
                </div>
              </div>
              <b-row style="display:flex;">
                <b-col style="padding-bottom:1%;" class="col-4">
                  <div class="chartBox">
                    <DeviceReportChart
                      :chartData="this.setChartData()"
                      :options="this.setChartOptions1()"
                    >
                    </DeviceReportChart>
                  </div>
                </b-col>
                <b-col style="padding-bottom:1%;" class="col-4">
                  <div class="chartBox">
                    <BiofilmChart
                      :chartData="this.setChartData2()"
                      :options="this.setChartOptions2()"
                    >
                    </BiofilmChart>
                  </div>
                </b-col>
                <b-col style="padding-bottom:1%;" class="col-4">
                  <div class="chartBox">
                    <TempChart
                      :chartData="this.setChartData3()"
                      :options="this.setChartOptions3()"
                    >
                    </TempChart>
                  </div>
                </b-col>
              </b-row>
            </div>
          </div>
        </div>
      </div>
    </b-container>

    <div v-if="ProfilePortal != 'CEU'">
      <div
        id="Data"
        v-if="this.Multipipe != 'TRUE' || this.MultipipeDataShow == true"
      >
        <b-row
          id="ButtonRow"
          v-if="this.Multipipe != 'TRUE' || this.MultipipeDataShow == true"
        >
          <b-col>
            <p id="Selector">
              <b-button @click="visible = !visible" class="button"
                >Show/Hide Readings</b-button
              >
            </p>
          </b-col>
        </b-row>
        <b-collapse v-model="visible" id="collapse-3">
          <b-row>
            <b-col><h5 id="MiddleSector">Select readings for table</h5> </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-row> <p id="Selector">Temperature:</p> </b-row>
              <b-row>
                <b-form-checkbox
                  v-model="TempShow"
                  value="true"
                  unchecked-value="false"
                  switch
                  class="checkboxDiv"
                ></b-form-checkbox>
              </b-row>
            </b-col>
            <b-col>
              <b-row> <p id="Selector">Flow:</p> </b-row>
              <b-row>
                <b-form-checkbox
                  v-model="FlowShow"
                  value="true"
                  unchecked-value="false"
                  switch
                  class="checkboxDiv"
                ></b-form-checkbox>
              </b-row>
            </b-col>
            <!--  <b-col> <b-row> <p id="Selector"> Biofilm: </p> </b-row>
          <b-row> <select v-model="BioShow">
                 
                  <option value="true" >Include</option>
                  <option value="false" >Exclude</option>
           
                  </select> </b-row> </b-col> -->
          </b-row>

          <div
            class="DataContainer"
            v-if="
              this.Multipipe != 'TRUE' ||
                (this.Multipipe == 'TRUE') &
                  ((this.PipeAShow == 'true') & (this.PipeBShow != 'true')) ||
                (this.PipeAShow != 'true') & (this.PipeBShow == 'true')
            "
          >
            <!-- SINGLE PIPE TABLES -->
            <h5>
              All times are in
              <a
                href="https://www.google.com/search?q=utc+time+zone+now&rlz=1C1ONGR_en-GBGB988GB988&oq=utc+time+zone+now&aqs=chrome..69i57j0i22i30l9.3553j0j4&sourceid=chrome&ie=UTF-8"
                target="_blank"
                >UTC</a
              >
              time zone
            </h5>
            <p class="allUTC" id="dateUTC"></p>
            <img
              id="menuGraphic"
              align="right"
              src="../assets/excelSmall.png"
              v-on:click="
                exportTableToExcel(
                  'DeviceReport',
                  'Device_Detail_Report_Export_' +
                    new Date().toLocaleDateString()
                )
              "
            />
            <br />
            <span id="DeviceReport">
              <div
                v-if="
                  (TempShow == 'true') &
                    (FlowShow == 'true') &
                    (BioShow == 'true')
                "
              >
                <div v-for="(date, idx) in LabelDatesArray" :key="idx">
                  <h2 class="pageHeader">{{ date }}</h2>

                  <div v-if="TempTable[date] != null">
                    <h5>Temperature</h5>

                    <table class="table table-bordered ">
                      <thead>
                        <tr>
                          <th id="Temp">Time</th>
                          <th id="Temp">Min Temp</th>
                          <th id="Temp">Max Temp</th>
                          <th id="Temp">Med Temp</th>
                          <th id="Temp">Alert Level</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(date, idx) in TempTable[date]" :key="idx">
                          <td v-for="(item, idx) in date" :key="idx">
                            {{ item }}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div v-if="TempTable[date] == null">
                    <h5>Temperature</h5>
                    <p class="Centre">No Data Available</p>
                  </div>

                  <div v-if="FlowTable[date] != null">
                    <h5>Flow</h5>
                    <table class="table table-bordered">
                      <thead>
                        <tr>
                          <th id="Flow">Time</th>
                          <th id="Flow">Flow Occurrences</th>
                          <th id="Flow">No. Of Flow Events</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(date, idx) in FlowTable[date]" :key="idx">
                          <td v-for="(item, idx) in date" :key="idx">
                            {{ item }}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div v-if="FlowTable[date] == null">
                    <h5>Flow</h5>
                    <p class="Centre">No Data Available</p>
                  </div>
                </div>
              </div>

              <div
                v-if="
                  (TempShow == 'false') &
                    (FlowShow == 'true') &
                    (BioShow == 'true')
                "
              >
                <div v-for="(date, idx) in LabelDatesArray" :key="idx">
                  <h2 class="pageHeader">{{ date }}</h2>

                  <div v-if="FlowTable[date] != null">
                    <h5>Flow</h5>
                    <table class="table table-bordered">
                      <thead>
                        <tr>
                          <th id="Flow">Time</th>
                          <th id="Flow">Flow Occurrences</th>
                          <th id="Flow">No. Of Flow Events</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(date, idx) in FlowTable[date]" :key="idx">
                          <td v-for="(item, idx) in date" :key="idx">
                            {{ item }}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div v-if="FlowTable[date] == null">
                    <h5>Flow</h5>
                    <p class="Centre">No Data Available</p>
                  </div>
                </div>
              </div>

              <div
                v-if="
                  (TempShow == 'false') &
                    (FlowShow == 'false') &
                    (BioShow == 'true')
                "
              >
                <div v-for="(date, idx) in LabelDatesArray" :key="idx">
                  <h2 class="pageHeader">{{ date }}</h2>
                </div>
              </div>

              <div
                v-if="
                  (TempShow == 'false') &
                    (FlowShow == 'true') &
                    (BioShow == 'false')
                "
              >
                <div v-for="(date, idx) in LabelDatesArray" :key="idx">
                  <h2 class="pageHeader">{{ date }}</h2>

                  <div v-if="FlowTable[date] != null">
                    <h5>Flow</h5>
                    <table class="table table-bordered">
                      <thead>
                        <tr>
                          <th id="Flow">Time</th>
                          <th id="Flow">Flow Occurrences</th>
                          <th id="Flow">No. Of Flow Events</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(date, idx) in FlowTable[date]" :key="idx">
                          <td v-for="(item, idx) in date" :key="idx">
                            {{ item }}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div v-if="FlowTable[date] == null">
                    <h5>Flow</h5>
                    <p class="Centre">No Data Available</p>
                  </div>
                </div>
              </div>

              <div
                v-if="
                  (TempShow == 'true') &
                    (FlowShow == 'false') &
                    (BioShow == 'false')
                "
              >
                <div v-for="(date, idx) in LabelDatesArray" :key="idx">
                  <h2 class="pageHeader">{{ date }}</h2>
                  <div v-if="TempTable[date] != null">
                    <h5>Temperature</h5>

                    <table class="table table-bordered">
                      <thead>
                        <tr>
                          <th id="Temp">Time</th>
                          <th id="Temp">Min Temp</th>
                          <th id="Temp">Max Temp</th>
                          <th id="Temp">Med Temp</th>
                          <th id="Temp">Alert Level</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(date, idx) in TempTable[date]" :key="idx">
                          <td v-for="(item, idx) in date" :key="idx">
                            {{ item }}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div v-if="TempTable[date] == null">
                    <h5>Temperature</h5>
                    <p class="Centre">No Data Available</p>
                  </div>
                </div>
              </div>

              <div
                v-if="
                  (TempShow == 'true') &
                    (FlowShow == 'true') &
                    (BioShow == 'false')
                "
              >
                <div v-for="(date, idx) in LabelDatesArray" :key="idx">
                  <h2 class="pageHeader">{{ date }}</h2>
                  <div v-if="TempTable[date] != null">
                    <h5>Temperature</h5>

                    <table class="table table-bordered">
                      <thead>
                        <tr>
                          <th id="Temp">Time</th>
                          <th id="Temp">Min Temp</th>
                          <th id="Temp">Max Temp</th>
                          <th id="Temp">Med Temp</th>
                          <th id="Temp">Alert Level</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(date, idx) in TempTable[date]" :key="idx">
                          <td v-for="(item, idx) in date" :key="idx">
                            {{ item }}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div v-if="TempTable[date] == null">
                    <h5>Temperature</h5>
                    <p class="Centre">No Data Available</p>
                  </div>

                  <div v-if="FlowTable[date] != null">
                    <h5>Flow</h5>
                    <table class="table table-bordered">
                      <thead>
                        <tr>
                          <th id="Flow">Time</th>
                          <th id="Flow">Flow Occurrences</th>
                          <th id="Flow">No. Of Flow Events</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(date, idx) in FlowTable[date]" :key="idx">
                          <td v-for="(item, idx) in date" :key="idx">
                            {{ item }}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div v-if="FlowTable[date] == null">
                    <h5>Flow</h5>
                    <p class="Centre">No Data Available</p>
                  </div>
                </div>
              </div>

              <div
                v-if="
                  (TempShow == 'true') &
                    (FlowShow == 'false') &
                    (BioShow == 'true')
                "
              >
                <div v-for="(date, idx) in LabelDatesArray" :key="idx">
                  <h2 class="pageHeader">{{ date }}</h2>
                  <div v-if="TempTable[date] != null">
                    <h5>Temperature</h5>
                    <table class="table table-bordered">
                      <thead>
                        <tr>
                          <th id="Temp">Time</th>
                          <th id="Temp">Min Temp</th>
                          <th id="Temp">Max Temp</th>
                          <th id="Temp">Med Temp</th>
                          <th id="Temp">Alert Level</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(date, idx) in TempTable[date]" :key="idx">
                          <td v-for="(item, idx) in date" :key="idx">
                            {{ item }}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div v-if="TempTable[date] == null">
                    <h5>Temperature</h5>
                    <p class="Centre">No Data Available</p>
                  </div>
                </div>
              </div>
            </span>
          </div>

          <!-- END OF SINGLE PIPE TABLES -->

          <!-- START OF MULTIPIPE TABLES -->
          <span id="DeviceReport">
            <div
              class="DataContainer"
              v-if="
                (this.Multipipe == 'TRUE') &
                  (this.MultipipeDataShow == true) &
                  (this.PipeAShow == 'true') &
                  (this.PipeBShow == 'true')
              "
            >
              <div v-if="(TempShow == 'true') & (FlowShow == 'true')">
                <div v-for="(date, idx) in LabelDatesArray" :key="idx">
                  <h2 class="pageHeader">{{ date }}</h2>
                  <h3>Pipe A</h3>
                  <div v-if="TempTable[date] != null">
                    <h5>Temperature</h5>

                    <table class="table table-bordered">
                      <thead>
                        <tr>
                          <th id="Temp">Time</th>
                          <th id="Temp">Min Temp</th>
                          <th id="Temp">Max Temp</th>
                          <th id="Temp">Med Temp</th>
                          <th id="Temp">Alert Level</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(date, idx) in TempTable[date]" :key="idx">
                          <td v-for="(item, idx) in date" :key="idx">
                            {{ item }}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div v-if="TempTable[date] == null">
                    <h5>Temperature</h5>
                    <p class="Centre">No Data Available</p>
                  </div>

                  <div v-if="FlowTable[date] != null">
                    <h5>Flow</h5>
                    <table class="table table-bordered">
                      <thead>
                        <tr>
                          <th id="Flow">Time</th>
                          <th id="Flow">Flow Occurrences</th>
                          <th id="Flow">No. Of Flow Events</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(date, idx) in FlowTable[date]" :key="idx">
                          <td v-for="(item, idx) in date" :key="idx">
                            {{ item }}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div v-if="FlowTable[date] == null">
                    <h5>Flow</h5>
                    <p class="Centre">No Data Available</p>
                  </div>

                  <h3>Pipe B</h3>
                  <div v-if="TempTableB[date] != null">
                    <h5>Temperature</h5>

                    <table class="table table-bordered">
                      <thead>
                        <tr>
                          <th id="Temp">Time</th>
                          <th id="Temp">Min Temp</th>
                          <th id="Temp">Max Temp</th>
                          <th id="Temp">Med Temp</th>
                          <th id="Temp">Alert Level</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(date, idx) in TempTableB[date]" :key="idx">
                          <td v-for="(item, idx) in date" :key="idx">
                            {{ item }}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div v-if="TempTableB[date] == null">
                    <h5>Temperature</h5>
                    <p class="Centre">No Data Available</p>
                  </div>

                  <div v-if="FlowTableB[date] != null">
                    <h5>Flow</h5>
                    <table class="table table-bordered">
                      <thead>
                        <tr>
                          <th id="Flow">Time</th>
                          <th id="Flow">Flow Occurrences</th>
                          <th id="Flow">No. Of Flow Events</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(date, idx) in FlowTableB[date]" :key="idx">
                          <td v-for="(item, idx) in date" :key="idx">
                            {{ item }}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div v-if="FlowTableB[date] == null">
                    <h5>Flow</h5>
                    <p class="Centre">No Data Available</p>
                  </div>
                </div>
              </div>

              <div v-if="(TempShow == 'true') & (FlowShow == 'false')">
                <div v-for="(date, idx) in LabelDatesArray" :key="idx">
                  <h2 class="pageHeader">{{ date }}</h2>
                  <h3>Pipe A</h3>
                  <div v-if="TempTable[date] != null">
                    <h5>Temperature</h5>

                    <table class="table table-bordered">
                      <thead>
                        <tr>
                          <th id="Temp">Time</th>
                          <th id="Temp">Min Temp</th>
                          <th id="Temp">Max Temp</th>
                          <th id="Temp">Med Temp</th>
                          <th id="Temp">Alert Level</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(date, idx) in TempTable[date]" :key="idx">
                          <td v-for="(item, idx) in date" :key="idx">
                            {{ item }}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div v-if="TempTable[date] == null">
                    <h5>Temperature</h5>
                    <p class="Centre">No Data Available</p>
                  </div>

                  <h3>Pipe B</h3>
                  <div v-if="TempTableB[date] != null">
                    <h5>Temperature</h5>

                    <table class="table table-bordered">
                      <thead>
                        <tr>
                          <th id="Temp">Time</th>
                          <th id="Temp">Min Temp</th>
                          <th id="Temp">Max Temp</th>
                          <th id="Temp">Med Temp</th>
                          <th id="Temp">Alert Level</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(date, idx) in TempTableB[date]" :key="idx">
                          <td v-for="(item, idx) in date" :key="idx">
                            {{ item }}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div v-if="TempTableB[date] == null">
                    <h5>Temperature</h5>
                    <p class="Centre">No Data Available</p>
                  </div>
                </div>
              </div>

              <div v-if="(TempShow == 'false') & (FlowShow == 'true')">
                <div v-for="(date, idx) in LabelDatesArray" :key="idx">
                  <h2 class="pageHeader">{{ date }}</h2>
                  <h3>Pipe A</h3>

                  <div v-if="FlowTable[date] != null">
                    <h5>Flow</h5>
                    <table class="table table-bordered">
                      <thead>
                        <tr>
                          <th id="Flow">Time</th>
                          <th id="Flow">Flow Occurrences</th>
                          <th id="Flow">No. Of Flow Events</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(date, idx) in FlowTable[date]" :key="idx">
                          <td v-for="(item, idx) in date" :key="idx">
                            {{ item }}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div v-if="FlowTable[date] == null">
                    <h5>Flow</h5>
                    <p class="Centre">No Data Available</p>
                  </div>

                  <h3>Pipe B</h3>

                  <div v-if="FlowTableB[date] != null">
                    <h5>Flow</h5>
                    <table class="table table-bordered">
                      <thead>
                        <tr>
                          <th id="Flow">Time</th>
                          <th id="Flow">Flow Occurrences</th>
                          <th id="Flow">No. Of Flow Events</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(date, idx) in FlowTableB[date]" :key="idx">
                          <td v-for="(item, idx) in date" :key="idx">
                            {{ item }}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div v-if="FlowTableB[date] == null">
                    <h5>Flow</h5>
                    <p class="Centre">No Data Available</p>
                  </div>
                </div>
              </div>
            </div>
          </span>
        </b-collapse>
      </div>
    </div>

    <vue-html2pdf
      :show-layout="false"
      :float-layout="true"
      :enable-download="false"
      :preview-modal="true"
      :paginate-elements-by-height="2400"
      :filename="'DeviceDetailReport'"
      :pdf-quality="2"
      :manual-pagination="true"
      pdf-format="a4"
      pdf-orientation="portrait"
      pdf-content-width="800px"
      :html-to-pdf-options="htmlToPdfOptions"
      @progress="onProgress($event)"
      @hasStartedGeneration="hasStartedGeneration()"
      @hasGenerated="hasGenerated($event)"
      ref="html2pdf"
    >
      <section slot="pdf-content">
        <!-- PDF Content Here -->
        <div class="PDFContainer">
          <b-container>
            <div class="mainDiv">
              <div>
                <!-- <span >  <a href="Dashboard" class="returnLink" > Return to Dashboard </a> </span> -->
                <div class="deviceDetails">
                  <h1 class="pageHeader">Device Detail Report</h1>

                  <b-row class="deviceInfo" v-if="this.Multipipe != 'TRUE'">
                    <b-col sm="3">
                      <p class="headerText">
                        Device:
                        <span class="dataText"> <br />{{ this.DeviceID }}</span>
                      </p>
                    </b-col>
                    <b-col sm="3">
                      <p class="headerText">
                        Location:
                        <span class="dataText">
                          <br />{{ this.Location }}
                        </span>
                      </p>
                    </b-col>
                    <b-col sm="3">
                      <p class="headerText">
                        Position:
                        <span class="dataText">
                          <br />{{ this.Position }}
                        </span>
                      </p>
                    </b-col>
                    <b-col sm="3">
                      <p v-if="this.Score > 850" class="headerText">
                        Current Risk Level:
                        <span class="dataText">
                          <br />
                          Low Risk
                        </span>
                      </p>
                      <p
                        v-if="(this.Score < 850) & (this.Score >= 500)"
                        class="headerText"
                      >
                        Current Risk Level:
                        <span class="dataText">
                          <br />
                          Moderate Risk
                        </span>
                      </p>
                      <p
                        v-if="(this.Score < 500) & (this.Score > 150)"
                        class="headerText"
                      >
                        Current Risk Level:
                        <span class="dataText">
                          <br />
                          High Risk
                        </span>
                      </p>
                      <p v-if="this.Score < 150" class="headerText">
                        Current Risk Level:
                        <span class="dataText">
                          <br />
                          Extremely High Risk
                        </span>
                      </p>
                    </b-col>
                  </b-row>
                  <b-row class="deviceInfo" v-if="this.Multipipe == 'TRUE'">
                    <b-col sm="4">
                      <p class="headerText">
                        Device:
                        <span class="dataText"> <br />{{ this.DeviceID }}</span>
                      </p>
                    </b-col>
                    <b-col sm="4">
                      <p class="headerText">
                        Location:
                        <span class="dataText">
                          <br />{{ this.Location }}
                        </span>
                      </p>
                    </b-col>
                    <b-col sm="4">
                      <p class="headerText">
                        Position:
                        <span class="dataText">
                          <br />{{ this.Position }}
                        </span>
                      </p>
                    </b-col>
                  </b-row>
                </div>
                <div class="filterBox">
                  <b-row>
                    <b-col
                      ><p id="Selector">
                        From Date: <br />
                        <b-form-datepicker
                          type="date"
                          v-model="FromDate"
                          @focus="modal = false"
                        />
                      </p>
                    </b-col>
                    <b-col
                      ><p id="Selector">
                        To Date: <br />
                        <b-form-datepicker
                          type="date"
                          v-model="ToDate"
                          @focus="modal = false"
                        />
                      </p>
                    </b-col>
                  </b-row>
                  <b-row v-if="this.Multipipe == 'TRUE'">
                    <p id="Selector">Select a Specific Pipe's Data</p>

                    <b-col>
                      <b-row> <p id="Selector">Pipe A</p> </b-row>
                      <b-row>
                        <b-form-checkbox
                          v-model="PipeAShow"
                          value="true"
                          unchecked-value="false"
                          switch
                          class="checkboxDiv"
                        ></b-form-checkbox>
                      </b-row>
                    </b-col>
                    <b-col>
                      <b-row> <p id="Selector">PipeB</p> </b-row>
                      <b-row>
                        <b-form-checkbox
                          v-model="PipeBShow"
                          value="true"
                          unchecked-value="false"
                          switch
                          class="checkboxDiv"
                        ></b-form-checkbox>
                      </b-row>
                    </b-col>
                  </b-row>
                </div>
              </div>
              <b-row style="display:flex;" class="col-8">
                <div class="chartBoxPDF">
                  <DeviceReportChart
                    :chartData="this.setChartData()"
                    :options="this.setChartOptions1()"
                    class="chartPDF"
                  >
                  </DeviceReportChart>
                </div>
              </b-row>
              <b-row style="display:flex; padding-bottom :3rem;" class="col-8">
                <div class="chartBoxPDF">
                  <BiofilmChart
                    :chartData="this.setChartData2()"
                    :options="this.setChartOptions2()"
                    class="chartPDF"
                  >
                  </BiofilmChart>
                </div>
              </b-row>
              <b-row style="display:flex;" class="col-8">
                <div class="chartBoxPDF">
                  <TempChart
                    :chartData="this.setChartData3()"
                    :options="this.setChartOptions3()"
                    class="chartPDF"
                  >
                  </TempChart>
                </div>
              </b-row>
            </div>
          </b-container>
        </div>
      </section>
    </vue-html2pdf>
  </div>
</template>

<script>
import axios from "axios";
import DeviceReportChart from "../components/DeviceFlowChart.vue";
import BiofilmChart from "../components/DeviceBioFilmChart.vue";
import TempChart from "../components/DeviceTempChart.vue";
import VueHtml2pdf from "vue-html2pdf";

export default {
  components: {
    DeviceReportChart,
    BiofilmChart,
    TempChart,
    VueHtml2pdf,
  },

  computed: {
    htmlToPdfOptions() {
      return {
        margin: 2,
        filename: "hee hee.pdf",
        image: {
          type: "jpeg",
          quality: 0.98,
        },
        pagebreak: { mode: "avoid-all", after: ".avoidThisRow" },
      };
    },

    rows() {
      return this.items.length;
    },
  },
  data() {
    return {
      DeviceID: "",
      FromDate: "",
      ToDate: "",
      modal: false,
      CounterVal: null,
      ReportError: "False",
      TodayDate: "",
      TodayTime: "",
      LabelDates: "",
      LabelDatesArray: [],
      responseArray: [],
      TempArray: [],
      GraphArray: [],
      FlowArray: [],
      BioArray: [],
      DateArray: [],
      TableArray: [],
      TableData: [],
      TempData: [],
      Dates: "",
      TempTable: {},
      FlowTable: {},
      BioTable: {},
      Position: "",
      Location: "",
      hover: false,
      TempShow: "true",
      BioShow: "true",
      FlowShow: "true",
      ProfilePortal: this.$ProfilePortal,
      Score: "",
      Multipipe: "",
      PipeAID: "",
      PipeBID: "",
      PipeAShow: "",
      PipeBShow: "",
      PipeADataArray: [],
      PipeBDataArray: [],
      TempBArray: [],
      BioBArray: [],
      MultipipeDataShow: false,
      TempTableB: [],
      FlowTableB: [],
      visible: false,
      buttonCooldown: false,
    };
  },
  mounted() {
    this.DeviceID = localStorage.getItem("PassID");
    this.Position = localStorage.getItem("DevPosition");
    this.Location = localStorage.getItem("DevLocation");
    this.Multipipe = localStorage.getItem("DevMultiPipe");

    /* COMMENT BELOW CODE TO STOP THE REMOVAL OF ID's WHEN PAGE REFRESH */

    localStorage.removeItem("PassID");
    localStorage.removeItem("DevPosition");
    localStorage.removeItem("DevLocation");
    localStorage.removeItem("DevMultiPipe");

    let current = new Date();
    this.TodayDate =
      current.getFullYear() +
      "-" +
      (current.getMonth() + 1) +
      "-" +
      current.getDate();

    let date = new Date();
    date.setDate(date.getDate() - 1);

    let Yesterday =
      date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate();

    this.ToDate = this.TodayDate;
    this.FromDate = Yesterday;

    let LookUpURL2 =
      "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
      this.$environment +
      "/dashboard";
    let LookUpHeaders2 = this.$apikeyPost;
    let LookUpData2 = {
      Report: "DeviceDetail",
      RequestVariable: "415068510",
      FromDate: "2023-01-13",
      ToDate: this.TodayDate,
    };

    axios.post(LookUpURL2, LookUpData2, LookUpHeaders2).then((response) => {
      this.Score = response.data.Device[0][2];
      (this.responseArray = []),
        (this.TempArray = []),
        (this.LabelDatesArray = response.data.Values[0]);
      this.GraphArray = response.data.Values[1];
      this.TempArray = this.GraphArray[0];
      this.FlowArray = this.GraphArray[1];
      this.BioArray = this.GraphArray[2];
      this.TableArray = response.data.Values;
      this.Dates = this.TableArray[0];
      this.TempTable = response.data.Values[2];
      this.FlowTable = response.data.Values[3];
      this.BioTable = response.data.Values[4];
      this.Recirculatory = response.data.Device[0][3];
    });
  },

  methods: {
    generateReport() {
      this.$refs.html2pdf.generatePdf();
    },

    btnCooldown: function() {
      let buttonid = "button";
      const button = document.querySelector("#" + buttonid + "");
      if (this.buttonCooldown == true) {
        const disableButton = () => {
          button.disabled = true;
        };
        button.addEventListener("click", disableButton);
      } else if (this.buttonCooldown == false) {
        button.disabled = false;
      }
    },
    backToDash() {
      this.$router.push("/Dashboard");
    },

    resetValue: function() {
      this.visible = false;
      this.location = "";
      this.modal = false;
      this.FromDate = "";
      this.ToDate = "";
      this.showReport = "False";
      this.selectedReport = null;
      this.UnitID = "";
      this.CounterVal = null;
      this.ReportError = "False";

      if (this.Multipipe == "TRUE") {
        this.PipeAID = this.DeviceID + "A";
        this.PipeBID = this.DeviceID + "B";

        let current = new Date();
        this.TodayDate =
          current.getFullYear() +
          "-" +
          (current.getMonth() + 1) +
          "-" +
          current.getDate();

        let date = new Date();
        date.setDate(date.getDate() - 1);

        let Yesterday =
          date.getFullYear() +
          "-" +
          (date.getMonth() + 1) +
          "-" +
          date.getDate();

        this.ToDate = this.TodayDate;
        this.FromDate = Yesterday;

        this.LabelDatesArray = [];
        this.GraphArray = [];
        this.TempArray = [];
        this.FlowArray = [];
        this.BioArray = [];
        this.TableArray = [];
        this.Dates = [];
        this.TempTable = [];
        this.FlowTable = [];
        this.BioTable = [];
        this.PipeAShow = "";
        this.PipeBShow = "";
        this.MultipipeDataShow = false;

        // let LookUpURL1 = 'https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/PROD/dashboard'
        // let LookUpHeaders1 = this.$apikeyPost
        // let LookUpData1 = {Report: "DeviceDetail", RequestVariable:this.PipeAID, FromDate:Yesterday, ToDate:this.TodayDate, }

        // axios .post(LookUpURL1, LookUpData1,LookUpHeaders1)
        //   .then((response)=>{
        //
        //   })

        // let LookUpURL2 = 'https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/PROD/dashboard'
        // let LookUpHeaders2 = this.$apikeyPost
        // let LookUpData2 = {Report: "DeviceDetail", RequestVariable:this.PipeBID, FromDate:Yesterday, ToDate:this.TodayDate, }

        // axios .post(LookUpURL2, LookUpData2,LookUpHeaders2)
        //   .then((response)=>{
        //
        //   })
      } else if (this.Multipipe != "TRUE") {
        let current = new Date();
        this.TodayDate =
          current.getFullYear() +
          "-" +
          (current.getMonth() + 1) +
          "-" +
          current.getDate();

        let date = new Date();
        date.setDate(date.getDate() - 1);

        let Yesterday =
          date.getFullYear() +
          "-" +
          (date.getMonth() + 1) +
          "-" +
          date.getDate();

        this.ToDate = this.TodayDate;
        this.FromDate = Yesterday;

        this.buttonCooldown = true;

        let LookUpURL2 =
          "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
          this.$environment +
          "/dashboard";
        let LookUpHeaders2 = this.$apikeyPost;
        let LookUpData2 = {
          Report: "DeviceDetail",
          RequestVariable: this.DeviceID,
          FromDate: Yesterday,
          ToDate: this.TodayDate,
        };

        axios.post(LookUpURL2, LookUpData2, LookUpHeaders2).then((response) => {
          this.Score = response.data.Device[0][2];
          (this.responseArray = []),
            (this.TempArray = []),
            (this.LabelDatesArray = response.data.Values[0]);
          this.GraphArray = response.data.Values[1];
          this.TempArray = this.GraphArray[0];
          this.FlowArray = this.GraphArray[1];
          this.BioArray = this.GraphArray[2];
          this.TableArray = response.data.Values;
          this.Dates = this.TableArray[0];
          this.TempTable = response.data.Values[2];
          this.FlowTable = response.data.Values[3];
          this.BioTable = response.data.Values[4];
          this.Recirculatory = response.data.Device[0][3];
          this.buttonCooldown = false;
        });
      }
    },

    // dateUTC(){

    // },

    SoftReset() {
      var date = new Date();
      date.setDate(date.getDate() - 1);

      let Yesterday =
        date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate();

      this.ToDate = this.TodayDate;
      this.FromDate = Yesterday;
    },

    MultipipeFilter() {
      let LookUpURL2 =
        "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
        this.$environment +
        "/dashboard";
      let LookUpHeaders2 = this.$apikeyPost;
      let LookUpData2 = {
        Report: "DeviceDetail",
        RequestVariable: this.PipeBID,
        FromDate: this.FromDate,
        ToDate: this.ToDate,
      };

      axios.post(LookUpURL2, LookUpData2, LookUpHeaders2).then((response) => {
        this.PipeBDataArray = response.data.Values;
        this.LabelDatesArray = this.PipeADataArray[0];

        this.TempArray = this.PipeADataArray[1][0];
        this.TempBArray = this.PipeBDataArray[1][0];

        this.BioArray = this.PipeADataArray[1][2];
        this.BioBArray = this.PipeBDataArray[1][2];

        this.FlowArray = this.PipeADataArray[1][1];
        this.FlowBArray = this.PipeBDataArray[1][1];

        this.TempTable = this.PipeADataArray[2];
        this.TempTableB = this.PipeBDataArray[2];

        this.FlowTable = this.PipeADataArray[3];
        this.FlowTableB = this.PipeBDataArray[3];

        this.MultipipeDataShow = true;

        // this.responseArray = [],
        // this.TempArray = [],

        // this.LabelDatesArray = response.data.Values[0]
        // this.GraphArray = response.data.Values[1]

        // this.TempArray = this.GraphArray[0]
        // this.FlowArray = this.GraphArray[1]
        // this.BioArray = this.GraphArray[2]

        // this.TableArray = response.data.Values

        // this.Dates = this.TableArray[0]

        // this.TempTable = response.data.Values[2]
        // this.FlowTable = response.data.Values[3]
        // this.BioTable = response.data.Values[4]
      });
    },

    DynamicSelect: function() {
      if (this.Multipipe == "TRUE") {
        if ((this.PipeAShow == "true") & (this.PipeBShow == "true")) {
          /* Need something to allow for multiple chart datas and two sets of readings, will need to be in an array format whilst still allowing the single pipe one to work */

          /* PIPE A DATA */
          this.buttonCooldown = true;

          let LookUpURL1 =
            "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
            this.$environment +
            "/dashboard";
          let LookUpHeaders1 = this.$apikeyPost;
          let LookUpData1 = {
            Report: "DeviceDetail",
            RequestVariable: this.PipeAID,
            FromDate: this.FromDate,
            ToDate: this.ToDate,
          };

          axios
            .post(LookUpURL1, LookUpData1, LookUpHeaders1)
            .then((response) => {
              this.PipeADataArray = response.data.Values;
              this.MultipipeFilter();
              this.buttonCooldown = false;
              // this.responseArray = [],
              // this.TempArray = [],

              // this.LabelDatesArray = response.data.Values[0]
              // this.GraphArray = response.data.Values[1]

              // this.TempArray = this.GraphArray[0]
              // this.FlowArray = this.GraphArray[1]
              // this.BioArray = this.GraphArray[2]

              // this.TableArray = response.data.Values

              // this.Dates = this.TableArray[0]

              // this.TempTable = response.data.Values[2]
              // this.FlowTable = response.data.Values[3]
              // this.BioTable = response.data.Values[4]
            });
        } else if ((this.PipeAShow == "true") & (this.PipeBShow != "true")) {
          if (this.ToDate > this.TodayDate) {
            alert("Please ensure 'To Date' is not after todays date!");
            this.SoftReset();
          } else if (this.FromDate > this.ToDate) {
            alert("Please ensure 'From Date' is not after the 'To Date'!");
            this.SoftReset();
          } else {
            let LookUpURL2 =
              "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
              this.$environment +
              "/dashboard";
            let LookUpHeaders2 = this.$apikeyPost;
            let LookUpData2 = {
              Report: "DeviceDetail",
              RequestVariable: this.PipeAID,
              FromDate: this.FromDate,
              ToDate: this.ToDate,
            };

            axios
              .post(LookUpURL2, LookUpData2, LookUpHeaders2)
              .then((response) => {
                (this.responseArray = []),
                  (this.TempArray = []),
                  (this.LabelDatesArray = response.data.Values[0]);
                this.GraphArray = response.data.Values[1];

                this.TempArray = this.GraphArray[0];
                this.FlowArray = this.GraphArray[1];
                this.BioArray = this.GraphArray[2];

                this.TableArray = response.data.Values;

                this.Dates = this.TableArray[0];

                this.TempTable = response.data.Values[2];
                this.FlowTable = response.data.Values[3];
                this.BioTable = response.data.Values[4];

                this.MultipipeDataShow = true;
              });
          }
        } else if ((this.PipeAShow != "true") & (this.PipeBShow == "true")) {
          if (this.ToDate > this.TodayDate) {
            alert("Please ensure 'To Date' is not after todays date!");
            this.SoftReset();
          } else if (this.FromDate > this.ToDate) {
            alert("Please ensure 'From Date' is not after the 'To Date'!");
            this.SoftReset();
          } else {
            let LookUpURL2 =
              "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
              this.$environment +
              "/dashboard";
            let LookUpHeaders2 = this.$apikeyPost;
            let LookUpData2 = {
              Report: "DeviceDetail",
              RequestVariable: this.PipeBID,
              FromDate: this.FromDate,
              ToDate: this.ToDate,
            };

            axios
              .post(LookUpURL2, LookUpData2, LookUpHeaders2)
              .then((response) => {
                (this.responseArray = []),
                  (this.TempArray = []),
                  (this.LabelDatesArray = response.data.Values[0]);
                this.GraphArray = response.data.Values[1];

                this.TempArray = this.GraphArray[0];
                this.FlowArray = this.GraphArray[1];
                this.BioArray = this.GraphArray[2];

                this.TableArray = response.data.Values;

                this.Dates = this.TableArray[0];

                this.TempTable = response.data.Values[2];
                this.FlowTable = response.data.Values[3];
                this.BioTable = response.data.Values[4];

                this.MultipipeDataShow = true;
              });
          }
        } else if ((this.PipeAShow != "true") & (this.PipeBShow != "true")) {
          alert("Please select at least one pipe to see the data");
          this.SoftReset();
        }
      } else if (this.Multipipe != "TRUE") {
        if (this.ToDate > this.TodayDate) {
          alert("Please ensure 'To Date' is not after todays date!");
          this.SoftReset();
        } else if (this.FromDate > this.ToDate) {
          alert("Please ensure 'From Date' is not after the 'To Date'!");
          this.SoftReset();
        } else {
          this.buttonCooldown = true;
          let LookUpURL2 =
            "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
            this.$environment +
            "/dashboard";
          let LookUpHeaders2 = this.$apikeyPost;
          let LookUpData2 = {
            Report: "DeviceDetail",
            RequestVariable: this.DeviceID,
            FromDate: this.FromDate,
            ToDate: this.ToDate,
          };

          axios
            .post(LookUpURL2, LookUpData2, LookUpHeaders2)
            .then((response) => {
              (this.responseArray = []),
                (this.TempArray = []),
                (this.LabelDatesArray = response.data.Values[0]);
              this.GraphArray = response.data.Values[1];

              this.TempArray = this.GraphArray[0];
              this.FlowArray = this.GraphArray[1];
              this.BioArray = this.GraphArray[2];
              this.TableArray = response.data.Values;
              this.Dates = this.TableArray[0];
              this.TempTable = response.data.Values[2];
              this.FlowTable = response.data.Values[3];
              this.BioTable = response.data.Values[4];
              this.buttonCooldown = false;
            });
        }
      }
    },
    setChartData() {
      if ((this.PipeAShow == "true") & (this.PipeBShow == "true")) {
        if (this.Recirculatory != "TRUE") {
          return {
            labels: this.LabelDatesArray,
            datasets: [
              {
                label: "No of Flow Events Pipe A",
                backgroundColor: "rgb(125, 125, 255)",
                data: this.FlowArray,
              },
              {
                label: "No of Flow Events Pipe B",
                backgroundColor: "rgb(100,75,175)",
                data: this.FlowBArray,
              },
            ],
          };
        } else if (this.Recirculatory == "TRUE") {
          return {
            labels: this.LabelDatesArray,
            datasets: [
              {
                label: "No of Flow Interruptions Pipe A",
                backgroundColor: "rgb(125, 125, 255)",
                data: this.FlowArray,
              },
              {
                label: "No of Flow Events Pipe B",
                backgroundColor: "rgb(100,75,175)",
                data: this.FlowBArray,
              },
            ],
          };
        }
      } else {
        if (this.Recirculatory != "TRUE") {
          return {
            labels: this.LabelDatesArray,
            datasets: [
              {
                label: "No of Flow Events",
                backgroundColor: "rgb(125, 125, 255)",
                data: this.FlowArray,
              },
            ],
          };
        } else if (this.Recirculatory == "TRUE") {
          return {
            labels: this.LabelDatesArray,
            datasets: [
              {
                label: "No of Flow Interruptions",
                backgroundColor: "rgb(125, 125, 255)",
                data: this.FlowArray,
              },
            ],
          };
        }
      }
    },

    setChartData2() {
      if ((this.PipeAShow == "true") & (this.PipeBShow == "true")) {
        return {
          labels: this.LabelDatesArray,
          datasets: [
            {
              label: "Biofilm Level Pipe A (1-5)",
              fill: false,
              borderColor: "rgb(125, 255, 125)",
              spanGaps: true,
              tension: 0.25,
              data: this.BioArray,
            },
            {
              label: "Biofilm Level Pipe B (1-5)",
              fill: false,
              borderColor: "rgb(75, 175, 75)",
              spanGaps: true,
              tension: 0.25,
              data: this.BioBArray,
            },
          ],
        };
      } else {
        return {
          labels: this.LabelDatesArray,
          datasets: [
            {
              label: "Biofilm Level (1-5)",
              fill: false,
              borderColor: "rgb(125, 255, 125)",
              spanGaps: true,
              tension: 0.25,
              data: this.BioArray,
            },
          ],
        };
      }
    },

    setChartData3() {
      if ((this.PipeAShow == "true") & (this.PipeBShow == "true")) {
        return {
          labels: this.LabelDatesArray,
          datasets: [
            {
              label: "Temperature Pipe A (C)",
              fill: false,
              borderColor: "rgb(255, 125, 125)",
              spanGaps: true,
              tension: 0.25,
              data: this.TempArray,
            },
            {
              label: "Temperature Pipe B (C)",
              fill: false,
              borderColor: "rgb(175, 75, 100)",
              spanGaps: true,
              tension: 0.25,
              data: this.TempBArray,
            },
          ],
        };
      } else {
        return {
          labels: this.LabelDatesArray,
          datasets: [
            {
              label: "Temperature (C)",
              fill: false,
              borderColor: "rgb(255, 125, 125)",
              spanGaps: true,
              tension: 0.25,
              data: this.TempArray,
            },
          ],
        };
      }
    },
    setChartOptions1() {
      return {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          yAxes: [
            {
              ticks: {
                fontColor: "#000000",
                beginAtZero: true,
                suggestedMin: 0,
                precision: 0,
              },
            },
          ],
          xAxes: [{ ticks: { fontColor: "#000000", beginAtZero: true } }],
        },
        legend: { labels: { fontColor: "#000000" } },
      };
    },

    setChartOptions2() {
      return {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          yAxes: [
            {
              ticks: {
                fontColor: "#000000",
                beginAtZero: false,
                suggestedMin: 1,
                suggestedMax: 5,
                precision: 0,
              },
            },
          ],
          xAxes: [{ ticks: { fontColor: "#000000", beginAtZero: true } }],
        },
        legend: { labels: { fontColor: "#000000" } },
      };
    },
    setChartOptions3() {
      return {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          yAxes: [
            {
              ticks: {
                fontColor: "#000000",
                beginAtZero: true,
                suggestedMin: 0,
                precision: 0,
              },
            },
          ],
          xAxes: [{ ticks: { fontColor: "#000000", beginAtZero: true } }],
        },
        legend: { labels: { fontColor: "#000000" } },
      };
    },

    dualPipeCheck() {
      if (this.MultipipeDataShow == true) {
        this.MultipipeDataShow = false;
        this.visible = false;
      }
    },
    exportTableToExcel: function(tableID, filename = "") {
      var downloadLink;
      var dataType = "application/vnd.ms-excel";
      var tableSelect = document.getElementById(tableID);
      var tableHTML = tableSelect.outerHTML.replace(/ /g, "%20");

      // Specify file name
      filename = filename ? filename + ".xls" : "excel_data.xls";

      // Create download link element
      downloadLink = document.createElement("a");

      document.body.appendChild(downloadLink);
      if (navigator.msSaveOrOpenBlob) {
        var blob = new Blob(["\ufeff", tableHTML], {
          type: dataType,
        });
        navigator.msSaveOrOpenBlob(blob, filename);
      } else {
        // Create a link to the file
        downloadLink.href = "data:" + dataType + ", " + tableHTML;

        // Setting the file name
        downloadLink.download = filename;
        //triggering the function
        downloadLink.click();
      }
    },
  },
  watch: {
    PipeAShow() {
      this.dualPipeCheck();
    },
    PipeBShow() {
      this.dualPipeCheck();
    },
    buttonCooldown() {
      this.btnCooldown();
    },
  },
};
</script>

<style scyAxed>
input[type="text"] {
  width: 80%;
  margin: 0px 0;
  padding: 2px 8px;
  position: relative;
}

.form-control {
  width: 100%;
  border: solid 1px rgba(200, 200, 200, 0.5);
  border-radius: 25px;
  background-color: rgb(245, 245, 245);
  font-size: 0.9rem;
}

table tr {
  background-color: #ffffff;
  color: black;
  text-align: center;
  font-size: small;
}

#temp {
  background: white;
}

#LeftChart {
  padding-left: 2.5%;
  width: 30%;
  float: left;
}
#CentreChart {
  width: 30%;
  float: left;
  padding-left: 5%;
}

#RightChart {
  width: 30%;
  float: left;
  padding-left: 5%;
}

#Flow {
  background-color: rgb(187, 187, 187);
  color: #444444;
}

#Temp {
  background-color: rgb(255, 255, 255);
  color: #444444;
}

#Bio {
  background-color: rgb(187, 187, 187);
  color: #444444;
}
#DataDump {
  border-top: solid 2px blue;
}
#Selector {
  text-align: center;
  width: 100%;
  padding-top: 10px;
  margin: 0;
  font-weight: 400;
}

.button {
  text-align: center;
}
#ButtonRow {
  padding-top: 25px;
}

.mainDiv {
  padding: 1rem;
}
.chartBox {
  border-radius: 25px;
  border: solid 1px rgb(180, 180, 180);
  background-color: rgb(255, 255, 255);
  padding: 0.5rem;
}
.chartBoxPDF {
  border-radius: 25px;
  border: solid 1px rgb(180, 180, 180);
  background-color: rgb(255, 255, 255);
  padding: 0.5rem;
  width: 700px;
  margin-left: 25px;
}
.chartPDF {
  width: 700px;
}
.deviceDetails {
  padding-left: 3rem;
  padding-right: 3rem;
  background-color: rgba(255, 255, 255, 0);
  margin-bottom: 1rem;
  min-height: 10rem;
  border: solid 1px rgba(180, 180, 180, 0);
}
.filterBox {
  padding-left: 3rem;
  padding-right: 3rem;
  background-color: rgba(255, 255, 255, 0);
  margin-bottom: 1rem;
  min-height: 10rem;
}
.filterButton {
  height: 2.2rem;
  padding-right: 1.2rem;
  padding-left: 1.2rem;
  margin-top: auto;
  margin-bottom: auto;
  float: right;
  text-align: center;
  color: white;
  text-align: center;
  background-color: rgb(60, 69, 78);
  border: solid 2px rgb(70, 70, 70);
}
.pageHeader {
  text-align: center;

  font-weight: 200;
  padding-top: 1rem;
  padding-bottom: 1rem;
}
.headerText {
  font-weight: 400;
}

.dataText {
  font-weight: 600;
}
a {
  margin: 0;
  padding: 0;
}
.returnLink {
  text-align: left;
  text-decoration: underline;
  font-weight: 500;
  position: absolute;
  margin-top: 2.5%;
  padding-left: 3rem;
  margin-left: -15px;
  cursor: pointer;
}

.deviceInfo {
  text-align: center;
  padding-top: 1rem;
  border-bottom: solid 2px rgb(220, 220, 220);
  border-top: solid 2px rgb(220, 220, 220);
}

.DataContainer {
  padding: 1.5rem;
}

tr:nth-child(even) {
  background-color: rgba(96, 96, 96, 0);
}

.SubmitRow {
  padding-bottom: 20px;
}

.Container {
  text-align: left;
}

.checkboxDiv {
  margin: 0;
  padding: 0;
  margin-top: 1rem;
  left: 54%;
  transform: translate(-50%, -50%);
}

.DataContainerPDF {
  width: 100%;
  height: 100%;
}
</style>
